import css from 'styled-jsx/css';

const styles = css.global`.rotoql-player-img__image{height:100%;width:auto}.rotoql-player-img__container{display:flex;align-items:center;justify-content:center;object-fit:cover;border:1px solid #f5f5f5;border-radius:50%;overflow:hidden}`;

export default styles;